import { useSelector } from "react-redux";
import Spinner from "../../../components/Spinner";
import { Navigate } from "react-router-dom";


type Props = {
  children: React.ReactNode;
};
const CreatorProtectedRoute = ({ children }: Props) => {
  const {user, loading} = useSelector((state: any) => state.auth || {});
  const isCreatorFromProfileUpdate = useSelector((state: any) => state.profile?.profile?.user?.role?.includes("creator"));
  const isCreator = isCreatorFromProfileUpdate || user?.role?.includes("creator");
  
    if(loading) {
      return <Spinner />;
    }

  if (!isCreator) {
    return <Navigate to="/" replace />;

  }

  return <>{children}</>;
};

export default CreatorProtectedRoute;

